
import { defineComponent } from 'vue';
import ResultInfo from './ResultInfo.vue';
import TheResetButton from './TheResetButton.vue';
export default defineComponent({
  name: 'TheCalculatorResultPanel',
  components: { ResultInfo, TheResetButton },
  computed: {
    tipAmount() {
      return this.$store.getters.tipAmount.toFixed(2);
    },
    totalPay() {
      return this.$store.getters.totalPay.toFixed(2);
    },
  },
});
